// ES6 version of single_input_modal.js (Drop-in replacement)
import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { Modal, Form, Button } from 'react-bootstrap';

const KeyboardUtil = require('../../util/keyboard');
const ValidateUtil = require('../../util/ValidateUtil');
import ErrorBox from '../common/ErrorBox';

const propTypes = {
    submitHandler: PropTypes.func.isRequired,
    closeHandler: PropTypes.func.isRequired,
    show: PropTypes.bool,
    defaultValue: PropTypes.string,
    headerText: PropTypes.string,
    inputLabel: PropTypes.string,
    ariaLabel: PropTypes.string,
    buttonText: PropTypes.string,
    multiline: PropTypes.bool
};

const defaultProps = {
    defaultValue: "",
    buttonText: "ok",
    multiline: false
};

class SingleInputModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inputValue: this.props.defaultValue || "",
            ...ValidateUtil.getDefaultValidationState(),
        };

        this.inputElem = React.createRef();
        this.onChangeInput = this.onChangeInput.bind(this);
        this.submitHandler = this.submitHandler.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.focusOnInput  = this.focusOnInput.bind(this);
    }

    componentDidMount() {
        this.focusOnInput();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState(ValidateUtil.getUpdatedStateFromNextProps(this.state, nextProps));
    }

    onChangeInput(e) {
        e.stopPropagation();
        this.setState({ inputValue: e.target.value });
    }

    submitHandler(e) {
        e.preventDefault(); // prevent page refresh when pressing enter in input box (TODO... WHY?)
        this.props.submitHandler(this.state.inputValue);
    }

    handleKeyDown(e) {
        e.stopPropagation();
        if (!this.props.multiline && KeyboardUtil.isEnterKey(e.keyCode)) {
            this.submitHandler(e);
        }
    }

    focusOnInput() {
        const inputElem = this.inputElem.current;
        if (!inputElem) {
            return;
        }

        inputElem.focus();
        if (!!this.props.defaultValue) {
            inputElem.setSelectionRange(0, inputElem.value.length);
        }
    }

    render(){
        return (
            <Modal
                className='single-input-modal'
                show={this.props.show}
                size="lg"
                enforceFocus={false}
                backdrop={false}
                animation={false}
                keyboard
                onHide={this.props.closeHandler}
            >
                <Modal.Header closeButton onHide={this.props.closeHandler}>
                    <Modal.Title as="div">{this.props.headerText}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <ErrorBox error={this.state.error} />
                    <Form>
                        <Form.Group controlId="single-input-modal-input">
                            <Form.Label>{this.props.inputLabel}</Form.Label>
                            <Form.Control
                                as={this.props.multiline ? 'textarea' : 'input'}
                                ref={this.inputElem}
                                aria-label={this.props.ariaLabel}
                                value={this.state.inputValue}
                                onChange={this.onChangeInput}
                                onKeyDown={this.handleKeyDown}
                                isInvalid={ValidateUtil.isInvalid(this.state, 'input')}
                            />
                        </Form.Group>
                    </Form>
                    {this.props.children}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="primary"
                        disabled={!!this.state.actionID}
                        onClick={this.submitHandler}
                    >
                        {this.props.buttonText}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

SingleInputModal.propTypes = propTypes;
SingleInputModal.defaultProps = defaultProps;

export default SingleInputModal;